export * from './consult/consult.components';
export { GeneralVitalSignComponent as VitalSignComponent } from './vital-sign/general-vital-sign.component';
